import styled, { css } from 'styled-components'

const SideBarSize = 78

export const Container = styled.main`
  width: 100vw;
  min-height: calc(100vh - 200px);
  margin-top: 50px;
  padding: 0 1.5rem;

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  @media only screen and (min-width: 800px) {
    margin: 60px 32px 0 ${SideBarSize + 32}px;
    padding: 0;
    width: unset;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`

export const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`

export const QuickAccess = styled.div`
  margin-bottom: 44px;
  .divBeta {
    display: flex;
    flex-direction: row;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 30px;
  }

  .beta {
    border-radius: 2px;
    align-items: center;
    padding: 2px;
    font-family: 'Montserrat';
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    width: 42px;
    height: 20px;
    background-color: ${({ theme }) =>
      theme.isDark ? 'rgba(8, 137, 198, 1)' : 'rgba(50, 183, 246, 0.3)'};
    color: ${({ theme }) => (theme.isDark ? 'rgba(182, 229, 252, 1)' : 'rgba(5, 81, 117, 1)')};
    margin-left: 0.5rem;
  }

  .cards {
    display: flex;
    gap: 16px;

    .card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 55px;

      width: 100%;

      padding: 16px 20px;

      border-radius: 5px;
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      transition: color 500ms ease;

      .icon {
        width: 34px;
        height: 34px;

        color: ${({ theme }) => `rgb(${theme.primary.base})`};
      }

      .text {
        font-size: 18px;
        font-weight: 500;
        line-height: 23px;
      }
    }
  }

  @media only screen and (min-width: 800px) {
    margin-bottom: 48px;

    .title {
      font-size: 24px;
      line-height: 29px;
      margin-bottom: 45px;
    }

    .cards {
      gap: 26px;

      .card {
        width: 300px;

        align-items: flex-end;
        flex-direction: row-reverse;

        padding: 110px 30px 14px 16px;

        .icon {
          width: 30px;
          height: 30px;
        }

        .text {
          font-size: 22px;
          line-height: 29px;
        }
      }
    }
  }
`

export const MyQuestionBooks = styled.div`
  .upper {
    display: flex;
    flex-direction: column;
    gap: 30px;

    margin-bottom: 30px;

    .title {
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
    }
  }

  @media only screen and (min-width: 800px) {
    .upper {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      gap: 54px;

      margin-bottom: 48px;

      .title {
        font-size: 24px;
        line-height: 29px;
      }

      .dropdown {
        width: 355px;
      }
    }
  }
`

export const Empty = styled.div`
  display: flex;
  gap: 34px;
  align-items: center;
  flex-direction: column;

  padding: 38px 26px 50px 26px;

  border-radius: 5px;
  border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

  .icon {
    width: 42px;
    height: 42px;

    color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
  }

  .text {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;

    text-align: center;
  }

  .link {
    color: ${({ theme }) => `rgb(${theme.background.low})`};
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};

    padding: 12px 16px;

    border-radius: 4px;

    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  @media only screen and (min-width: 800px) {
    padding: 130px 0 200px 0;

    gap: 0;

    .icon {
      width: 66px;
      height: 66px;

      margin-bottom: 60px;
    }

    .text {
      font-size: 24px;
      line-height: 31px;

      margin-bottom: 40px;
    }

    .link {
      font-size: 16px;
      line-height: 22px;

      padding: 14px 21px;
    }
  }
`

export const Loading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .loading-block {
    height: 174px;
  }

  @media only screen and (min-width: 800px) {
    .card {
      height: 120px;
    }
  }
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ExpandableList = styled(List)<{ fullHeight: number; isExpanded: boolean }>`
  max-height: 0;
  transition: all 0.3s ease-in-out;

  overflow: hidden;

  margin-top: 16px;

  ${({ isExpanded, fullHeight }) =>
    isExpanded &&
    css`
      max-height: ${fullHeight}px;
      margin-bottom: 16px;
    `}
`

export const SeeMoreButton = styled.button`
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

  background: none;

  color: ${({ theme }) => `rgb(${theme.primary.base})`};

  width: 100%;

  padding: 12px 0;

  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  @media only screen and (min-width: 800px) {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
  }
`

export const CardContainer = styled.div`
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};

  box-shadow: 2px 2px 4px 0px #0000001a;

  padding: 8px 16px 20px 16px;

  .start {
    display: flex;
    align-items: center;

    gap: 6px;

    .fake-chart {
      width: 92px;
      background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
      height: 92px;
      border-radius: 100%;
      flex-shrink: 0;
    }

    .name {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;

      margin-bottom: 2px;
    }

    .infos {
      margin-bottom: 8px;

      color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};

      font-size: 14px;
      font-weight: 500;
      line-height: 18px;

      .info {
        display: inline-block;
      }
    }
  }

  .end {
    margin-top: 14px;

    .link {
      display: flex;
      justify-content: center;

      font-size: 12px;
      font-weight: 400;
      line-height: 16px;

      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      color: ${({ theme }) => `rgb(${theme.primary.base})`};

      padding: 8px 0;
    }
  }

  @media only screen and (min-width: 800px) {
    display: flex;
    justify-content: space-between;

    gap: 16px;

    padding: 12px 36px 12px 12px;

    .start {
      gap: 46px;
    }

    .end {
      margin-top: 0;

      display: flex;
      align-items: center;
      justify-content: center;

      .link {
        width: 142px;
        padding: 14px 0;

        font-size: 16px;
        line-height: 22px;
      }
    }
  }

  @media only screen and (min-width: 1000px) {
    padding: 12px 110px 12px 12px;
  }
`

export const ChartContainer = styled.div`
  width: 94px;
  height: 94px;

  position: relative;

  cursor: pointer;

  .label {
    opacity: 0;
    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    pointer-events: none;

    transition: opacity 300ms ease;

    .value {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;

      text-align: center;
    }

    .text {
      font-size: 10px;
      font-weight: 600;
      line-height: 12px;

      text-align: center;
    }
  }

  .label[data-visible='true'] {
    opacity: 1;
  }

  .chart {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    outline: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0); /* mobile webkit */
  }
`

export const ProgressBar = styled.div<{ progress: number }>`
  height: 20px;

  border-radius: 100px;

  background-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};

  position: relative;

  .colored-bar {
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 100px;

    width: 100%;
    height: 100%;

    background-color: ${({ theme }) => `rgb(${theme.greenProgress[300]})`};

    overflow: hidden;

    clip-path: inset(0px ${({ progress }) => 100 - progress + '%'} 0px 0px round 100px);

    color: ${({ theme }) => `rgb(${theme.background.high})`};

    font-size: 12px;
    font-weight: 500;
    line-height: 14px;

    animation: grow 1s ease-out;
  }

  .text {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;

    white-space: nowrap;

    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    color: ${({ theme }) => `rgb(${theme.greenProgress[300]})`};

    &[data-no-progress='true'] {
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    }
  }

  @keyframes grow {
    0% {
      clip-path: inset(0px 100% 0px 0px round 100px);
    }
  }
`
